import moment from "moment";
export const getField = (info) => {
    const {
      type,
      name,
      active,
      editable,
      everyone,
      mandatory,
      size_from,
      size_to,
    } = info;
    let inputField;
  
    switch (type) {
      case "Section":
        
        break;
  
      case "Image":
        
        break;
  
      case "Header":
       
        break;
  
      case "Date":
        
        break;
  
      case "Phone Number":
       
        break;
  
      case "Page No":
        
        break;
  
      case "Name":
       
        break;
  
      case "Age":
       
        break;

      case "Gender":
        
        break;

      case "DOB":
        
        break;

      case "Vital":
        
        break;
    }
  
    return inputField;
  };


  
export function dateConvertToPayloadBookingFormat(date) {
  const inputDateString = date;

  const utcDate = moment.utc(inputDateString);

  const formattedDateString = utcDate.format("YYYY-MM-DDTHH:mm:ss[Z]");

  return formattedDateString;
}
  


export const getParentUser = (data) => {
  const filtered = data?.filter((ele) => ele?.is_parent === true);
  return filtered[0];
};